
import ServiceBase from "../../../servicebase";
import { ComprobanteEditIn, OperacionEstadoIn, PasajeroEditIn, PasajeroEditOut, PasajeroListOut, VoucherEditIn, VoucherEditOut, VoucherListOut, VoucherTemplateEditIn, VoucherTemplateEditOut, VoucherTemplateListOut } from "../../../../model/operaciones";
import { ControllerEntityService } from "./ControllerEntityService";
import { ComboItem } from "../../../../model/common/ComboItem";
import { PaginatedResponse, Response } from "../../../../model";
import { MovimientoListOut } from "../../../../model/operaciones/MovimientoListOut";

export class OperacionesService extends ServiceBase {
  private controller: string = 'operaciones';

  VoucherTemplate = () => new ControllerEntityService<VoucherTemplateEditOut, VoucherTemplateEditIn, VoucherTemplateListOut, ComboItem, { codigo?: string, nombre?: string }, {}>(this.urlAPI, this.controller, "VoucherTemplate");

  Voucher = () => new VoucherService(this.urlAPI, this.controller);

  Card = () => new CardService(this.urlAPI)
  
  Pasajero = () => new ControllerEntityService<PasajeroEditOut, PasajeroEditIn, PasajeroListOut, ComboItem, { }, {}>(this.urlAPI, this.controller, "Pasajero");

  Comprobante = () => new ComprobanteService(this.urlAPI);

  Operacion = () => new OperacionService(this.urlAPI);
  
  Movimiento = () => new ControllerEntityService<void, void, MovimientoListOut, ComboItem, { fechadesde?: string, fechahasta?: string, numeroOperacion?: string, numeroVoucher?: string, idLoteFacturacion?: number, excludeMovimientosEnLoteFacturacion?: boolean }, {}>(this.urlAPI, this.controller, "Movimiento");
}

class CardService extends ServiceBase {
  update = (data: { tipo: string, id: number, updates: { key: string, value: any }[] }) => 
    this.PostFetch<Response<void>>(`operaciones/card`, data);
}

class ComprobanteService extends ServiceBase {
  insert = (data: ComprobanteEditIn) => this.PostFetch<Response<number>>(`operaciones/comprobante`, data);
  
  delete = (data:{ id:number, undelete?: boolean}) => this.DeleteFetch<Response<void>>(`operaciones/comprobante`, data);
}

class OperacionService extends ServiceBase {
  estado = (data: OperacionEstadoIn) => this.PutFetch<Response<number>>(`operaciones/operacion/estado`, data);
  upgradeInfo = (data: { idOperacion?: number, operacionNumero?: number; }) => this.GetFetch<Response<any[]>>(`operaciones/operacion/upgradeInfo`, data);
  reemitir = (data: { id: number }) => this.PostFetch<Response<number>>(`operaciones/operacion/reemitir`, data);
}

type Voucher_TFindExtraFilters = { creafechaDesde?: string, creafechaHasta?: string, voucherNumero?:string, operacionNumero?: number, paxNombre?: string, paxApellido?: string, paxDocumento?: string };
export class VoucherService extends ControllerEntityService<VoucherEditOut, VoucherEditIn, VoucherListOut, ComboItem, Voucher_TFindExtraFilters, {}> {
  constructor(urlApi: string, controller: string) {
    super(urlApi, controller, "Voucher");
  }

  reporte = (data:Voucher_TFindExtraFilters & { pageIndex?: number, pageSize?: number, sort?: string }) =>
    this.GetFetch<PaginatedResponse<VoucherEditOut>>(`${this._controller}/${this._entity}/reporte`, data);

  upsert2 = (data:VoucherEditIn) : Promise<Response<VoucherEditOut>> => 
    this.PostFetch<Response<VoucherEditOut>>(`${this._controller}/${this._entity}`, data);


  SendEmail = (idOperacion?: number) => this.PostFetch<Response<void>>(`${this._controller}/${this._entity}/re-sendemail?idOperacion=${idOperacion}`, {});
}
